import React, { useEffect } from 'react'
import { GoogleReCaptcha } from 'react-google-recaptcha-v3'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import Cancel from '@/features/cancel/pages/CancelPage'
import Health from '@/features/healthExample/pages/HealthExamplePage'
import Login from '@/features/login/pages/LoginPage'
import Main from '@/features/main/pages/MainPage'
import Center from '@/features/support/index'
import { TermsDocument } from '@/features/support/notice/components/yuseoung-gu/TermsDocument'
import Terms from '@/features/terms/pages/TermsPage'
import UserPage from '@/features/user/index'
import Layout from '@/shared/components/layout'
import { SERVICE_JOIN_URL } from '@/shared/constant/url'
import { RecapAuthToken, RefreshRecapAuthToken } from '@/shared/store'

const JoinRedirect = () => {
  useEffect(() => {
    window.location.replace(SERVICE_JOIN_URL)
  }, [])

  return null
}

const LayoutWrapper = () => (
  <Layout>
    <Outlet />
  </Layout>
)
const App = () => {
  const setAuthToken = useSetRecoilState(RecapAuthToken)
  const refreshReCaptcha = useRecoilValue(RefreshRecapAuthToken)
  function handleVerify(value: any) {
    setAuthToken(value)
  }

  return (
    <BrowserRouter>
      <Sentry.ErrorBoundary>
        <Routes>
          <Route element={<LayoutWrapper />}>
            <Route path="/" element={<Main />} />
            <Route path="/healthExample/:idx" element={<Health />} />
            <Route path="/center" element={<Center />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/notice" element={<Center />} />
            <Route path="/news" element={<Center />} />
            <Route path="/notice/detail/:idx" element={<Center />} />
            <Route path="/terms" element={<Navigate to="/terms/0/1" />} />
            <Route path="/terms/:telecom" element={<Terms />} />
            <Route path="/terms/:telecom/:terms" element={<Terms />} />
            <Route path="/faq" element={<Center />} />
            <Route path="/refund" element={<Center />} />
            <Route path="/inquiry" element={<Center />} />
            <Route path="/login" element={<Login />} />
            <Route path="/userPage/main" element={<UserPage />} />
            <Route path="/userPage/letter/health" element={<UserPage />} />
            <Route path="/userPage/letter/life" element={<UserPage />} />
            <Route path="/userPage/letter/health/detail/:idx" element={<UserPage />} />
            <Route path="/userPage/letter/life/detail/:idx" element={<UserPage />} />
            <Route path="/userPage/fortune" element={<UserPage />} />
          </Route>
          <Route path="/join" element={<JoinRedirect />} />
          <Route path="/notice/detail/yuseong/:id" element={<TermsDocument />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <GoogleReCaptcha onVerify={handleVerify} refreshReCaptcha={refreshReCaptcha} />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  )
}
export default App
